import styled from 'styled-components'

export const Container = styled.div`
  width: 300px;
  right: -300px;
  position: fixed;
  background-color: #f7f8f9;
  z-index: 500;
  top: 0;
  bottom: 0;
  transition: all .3s ease-in-out;

  &.active {
    right: 0;
  }
`

export const Content = styled.div`
  max-height: calc(100vh - 52px);
  overflow-y: auto;
`
